import { render } from "./DeviceCompatibility.vue?vue&type=template&id=57ffff44&scoped=true"
import script from "./DeviceCompatibility.vue?vue&type=script&lang=js"
export * from "./DeviceCompatibility.vue?vue&type=script&lang=js"

import "./DeviceCompatibility.vue?vue&type=style&index=0&id=57ffff44&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ffff44"]])

export default __exports__